import { FundingPolicyType } from '@shared';

// DUPLICATE OF `POLICY_PRODUCT_NAME_MAPPING` / `getPolicyTypeFromProductName` in
// @shared/calculations/roi/calcClientROIProjections. The two are kept identical
// by findPartnerPolicyFundingSourceId.productNameMapping.test.ts — they drifted
// once already, which left shop-added CareMatters Annuity quotes resolving to NO
// policy type at all, so the projection fell through to the legacy path while
// looking perfectly normal.
export const POLICY_PRODUCT_NAME_MAPPING = {
  'Asset Care': FundingPolicyType.assetCare,
  'CareMatters® II': FundingPolicyType.careMattersTwo,
  'CareMatters® Together': FundingPolicyType.jointCareMatters,
  // Single-life and joint annuity rows share this one product name; the joint
  // split happens below, as it does for Asset Care.
  'CareMatters Annuity': FundingPolicyType.careMattersAnnuity,
  'CareScout Care Assurance': FundingPolicyType.careScoutCareAssurance,
  'CareScout': FundingPolicyType.careScoutCareAssurance, // Add shorter product name
  'MoneyGuard Fixed Advantage® (2025)': FundingPolicyType.moneyGuardFixedAdvantage,
  'SecureCare III': FundingPolicyType.secureCareThree,
  'SecureCare IV': FundingPolicyType.secureCareFour,
  'Bridge®': FundingPolicyType.equitrustBridge,
  'Bridge': FundingPolicyType.equitrustBridge,
  'Asset Flex': FundingPolicyType.nylAssetFlex,
  'AssetFlex': FundingPolicyType.nylAssetFlex,
} as const;

export const getPolicyTypeFromProductName = (
  productName: string,
  isJointPolicy: boolean = false,
): FundingPolicyType | undefined => {
  if (productName === 'Asset Care') {
    return isJointPolicy ? FundingPolicyType.jointAssetCare : FundingPolicyType.assetCare;
  }
  if (productName === 'CareMatters Annuity') {
    return isJointPolicy
      ? FundingPolicyType.jointCareMattersAnnuity
      : FundingPolicyType.careMattersAnnuity;
  }
  return POLICY_PRODUCT_NAME_MAPPING[productName as keyof typeof POLICY_PRODUCT_NAME_MAPPING];
};

export const findPartnerPolicyFundingSourceId = (
  partnerClient: Client,
  policyToMatch: {
    insuranceQuoteId?: string;
  },
): string | null => {
  if (!partnerClient.multipleFundingSources?.ltcPolicy) {
    return null;
  }

  if (policyToMatch.insuranceQuoteId) {
    for (const [partnerFundingId, partnerPolicy] of Object.entries(
      partnerClient.multipleFundingSources.ltcPolicy,
    )) {
      if (partnerPolicy.insuranceQuoteId === policyToMatch.insuranceQuoteId) {
        return partnerFundingId;
      }
    }
  }

  return null;
};

export const deleteJointPolicyFromBothClients = (
  dispatch: any,
  currentClient: Client,
  fundingSourceId: string,
  putMultipleFundingSourceForClientByClientIdRequest: any,
) => {
  const policyBeingDeleted = currentClient.multipleFundingSources?.ltcPolicy[fundingSourceId];

  dispatch(
    putMultipleFundingSourceForClientByClientIdRequest({
      clientId: currentClient.clientId,
      fundingSourceType: 'ltcPolicy',
      fundingSourceData: null,
      fundingSourceId,
    }),
  );

  if (
    policyBeingDeleted &&
    currentClient.mutableClientPartner &&
    policyBeingDeleted.insuranceQuoteId
  ) {
    const partnerFundingSourceId = findPartnerPolicyFundingSourceId(
      currentClient.mutableClientPartner,
      {
        insuranceQuoteId: policyBeingDeleted.insuranceQuoteId,
      },
    );

    if (partnerFundingSourceId) {
      dispatch(
        putMultipleFundingSourceForClientByClientIdRequest({
          clientId: currentClient.mutableClientPartner.clientId,
          fundingSourceType: 'ltcPolicy',
          fundingSourceData: null,
          fundingSourceId: partnerFundingSourceId,
        }),
      );
    }
  }
};
